var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-component"},[_c('ct-banner',{attrs:{"banner":_vm.banner}}),_c('ct-index-bar',{staticClass:"terms-index",attrs:{"route":"terms","title":"Termos de uso","items":_vm.anchors}}),_c('ct-terms-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }